export default {"src":"/_next/static/media/circle-clock.ee008db7.svg","height":512,"width":512};